var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallAngleConnector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  fillRule: "evenodd",
  d: "m0 24.506 8-.006v-20l-8 .005v20Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  d: "M8.877 24.5H29V0H8v24.5h.877Z"
})));
export { SvgSmallAngleConnector as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAyNC41MDU1TDggMjQuNVYyMy40OTk5VjQuNDk5OTJMMCA0LjUwNTQ0VjI0LjUwNTVaIiBmaWxsPSIjNTM1NjVCIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNOC44NzcyMiAyNC41SDI5VjBIOFY0LjQ5OTkyVjIzLjQ5OTlWMjQuNUg4Ljg3NzIyWiIgZmlsbD0iIzUzNTY1QiIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPC9zdmc+Cg==";